// extracted by mini-css-extract-plugin
export default {"Warning":"Warning_Warning__3M84q"};